import useArticleModalExposureActions from './useArticleModalExposureActions';
import useArticleModalQualitativeAnalysisActions from './useArticleModalQualitativeAnalysisActions';
import useArticleModalSentimentActions from './useArticleModalSentimentActions';
import useArticleModalStatusActions from './useArticleModalStatusActions';

const useArticleModalActions = ({
  applyArticleUpdate,
  isSentimentAIEnabled,
  localArticle,
  onToggleFavorite,
  onToggleRead,
  onUpdateSentiment,
  setKpiaModalOpen,
  setLocalArticle,
  showSnackbar
}) => {
  const statusActions = useArticleModalStatusActions({
    onToggleFavorite,
    onToggleRead,
    setLocalArticle
  });

  const sentimentActions = useArticleModalSentimentActions({
    isSentimentAIEnabled,
    localArticle,
    onUpdateSentiment,
    setLocalArticle,
    showSnackbar
  });

  const exposureActions = useArticleModalExposureActions({
    localArticle,
    setLocalArticle,
    showSnackbar
  });

  const qualitativeAnalysisActions = useArticleModalQualitativeAnalysisActions({
    applyArticleUpdate,
    localArticle,
    setKpiaModalOpen,
    showSnackbar
  });

  return {
    ...statusActions,
    ...sentimentActions,
    ...exposureActions,
    ...qualitativeAnalysisActions
  };
};

export default useArticleModalActions;
